import type { InjectionKey } from 'vue'
import type * as Vuex from '@/../node_modules/vuex/types'
import type { State } from './state'
// @ts-ignore
import { createStore, createLogger, useStore as useVuexStore } from 'vuex'
import rootStore from './root'
import effectsStore from './effects'
import Config from '@/config'

export const key: InjectionKey<Vuex.Store<State>> = Symbol('oauth-client-store')

export const store: Vuex.Store<State> = createStore<State>({
	...rootStore,
	modules: {
		effects: { ...effectsStore },
	},
	strict: !Config.isDev,
	plugins: Config.isLoggingEnabled ? [ createLogger() ] : []
})


export const useStore = (): Vuex.Store<State> => {
	return useVuexStore(key)
}

export type {
	Vuex
}

export type ActionContext = Vuex.ActionContext<State, State>

export type ActionTree = Vuex.ActionTree<State, State>
